export default __webpack_public_path__ + "static/media/A.12379fec.svg";